module.exports = __webpack_public_path__ + "static/media/logo-black.f12aeb14.svg";